module.exports = __webpack_public_path__ + "static/media/tickAppointment.619ee859.svg";